import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class CustomerStore extends LocalModel {
    constructor() {
        super('customer', {
            namePlural: 'customers',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/customers/',
                    params: {
                        limit: 15,
                        sort: '-createdDate',
                    },
                },
                load: {
                    url: '/api/customers/',
                    params: {},
                },
                save: {
                    url: '/api/customers/',
                    params: {},
                },
                delete: {
                    url: '/api/customers/',
                    params: {},
                },
            },
        });
    }

    @observable newCustomer = {};

    @observable customer = {};

    @observable customerPublic = {};

    @observable customers = [];

    @observable fikenBankAccounts = [];

    @observable members = [];

    // included.aiUsageStats from GET /api/customers/admin/?addData=aiUsageStats
    // (filled by LocalModel.adminLoad as admin<DataElement>).
    @observable adminAiUsageStats = [];

    /** Setup checklist per club, keyed by customer id (GET /api/customers/admin/:id/club-setup). */
    @observable clubSetup = {};

    async dyreIdRegisterClinicInfoV1(clinic) {
        const response = await util.fetchApi(`/api/dyreid/registerclinicinfov1/${clinic}`, { method: 'GET' }, {
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    async dyreIdRegisterVeterinarianInfoV1(veterinary) {
        const response = await util.fetchApi(`/api/dyreid/registerveterinarianinfov1/${veterinary}`, { method: 'GET' }, {
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    // type: Clinic, Vet
    async dyreIdGetclinicvettermsofuseacceptancestatusv1(clinicId, type = 'Clinic') {
        const response = await util.fetchApi(`/api/dyreid/getclinicvettermsofuseacceptancestatusv1/`, { method: 'GET' }, {
            clinicId,
            type,
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    // type: Clinic, Vet
    async dyreIdClinicVetTermsOfUseAcceptanceV1(clinicId, type = 'Clinic') {
        const response = await util.fetchApi(`/api/dyreid/clinicvettermsofuseacceptancev1/`, { method: 'GET' }, {
            clinicId,
            type,
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    async dyreIdGettermsandconditionslink(language) {
        const response = await util.fetchApi(`/api/dyreid/gettermsandconditionslink/`, { method: 'GET' }, {
            language,
        });
        switch (response?.status) {
            case 200:
                // this.updateKeyValue('breeds', response.data);
                return response;
        }
    }

    async loadPublic(id) {
        const response = await util.fetchApi(`/api/customers/public/${id}`, { method: 'GET' }, {});
        if (response?.status === 200) {
            this.updateKeyValue('customerPublic', response.data);
        }
    }

    async searchUsersAll(search) {
        if (!search || search.length < 2) {
            return [];
        }
        const response = await util.fetchApi('/api/users/search-all', { method: 'GET' }, { search });
        if (response?.status === 200) {
            return response.data || [];
        }
        return [];
    }

    async setNewsletterUnsubscribed(id, unsubscribed, source = 'self') {
        const response = await util.fetchApi('/api/customers/newsletter-unsubscribe', { method: 'POST' }, {
            id,
            unsubscribed: unsubscribed ? 1 : 0,
            source,
        });
        return response;
    }

    /**
     * Admin-only clinic validation (accounting/invoicing setup), mirrors raceStore.validateRace.
     * Returns the validation payload or null.
     */
    /** Shooting-club onboarding: create a tenant from the club template. */
    async adminCreateClub({ name, subdomain }) {
        const response = await util.fetchApi('/api/customers/admin/club', { method: 'POST' }, { name, subdomain });
        return response;
    }

    /** probe: 0 skips the server-side HTTPS probe (list scores for many clubs). */
    @action
    async loadClubSetup(customerId, { probe = 1 } = {}) {
        if (!customerId) {
            return null;
        }
        const response = await util.fetchApi(`/api/customers/admin/${customerId}/club-setup`, { method: 'GET' }, { probe });
        if (response?.status === 200) {
            this.updateKeyValue('clubSetup', { ...this.clubSetup, [customerId]: response.data });
            return response.data;
        }
        return null;
    }

    async validateCustomer(customerId) {
        if (!customerId) {
            return null;
        }
        const response = await util.fetchApi(`/api/customers/admin/${customerId}/validate`, { method: 'GET' }, {});
        if (response?.status === 200) {
            return response.data;
        }
        return null;
    }

    async setMemberInvoiceExtra(customerId, userId, value) {
        const response = await util.fetchApi(`/api/customers/admin/${customerId}`, { method: 'PATCH' }, {
            editMemberByUserId: userId,
            editMemberKey: 'invoiceExtra',
            editMemberValue: value,
            editMemberType: 'Boolean',
        });
        return response;
    }

}

const store = new CustomerStore();
export default store;
